// A post that earns its own picture. Most posts are painted by their room and
// a seeded shade (lib/brand/portal) and look like the family they belong to.
// A few big ones — a launch, an opening — get two more things, keeping the same
// card layout: an EXACT hue of their own (so they stand apart in the index), and
// a quiet layer of the thing they are about, drawn over the creature.
//
// Keyed by slug, in code, on purpose: the card composer only ever sees a url,
// and the `hue` column already means "re-seed the shade" for published posts.

export interface ArtCard {
  cat: string;
  title: string;
  by: string;
}

export interface PostArtEntry {
  /** the page's and the card's identity hue, exactly (no seeded shade) */
  hue: number;
  /** the ground's own hue when it should not follow the creature's (a teal
   *  netti on a deep blue-green ground); defaults to the house lead */
  groundHue?: number;
  /** skill cards fanned beside netti, the way the shelf looks */
  cards?: ArtCard[];
}

export const POST_ART: Record<string, PostArtEntry> = {
  "the-community-is-open": {
    hue: 172,
    groundHue: 198,
    cards: [
      { cat: "code · v1.0", title: "systematic debugging", by: "by obra" },
      { cat: "design · v1.0.0", title: "quiet interface", by: "kept by innernet" },
      { cat: "design", title: "frontend design", by: "by anthropic" },
    ],
  },
};

/** the seed suffix that marks a post painted from the registry */
export const ART_SUFFIX = "~art";

export function artForSeed(seed: string): PostArtEntry | null {
  if (!seed.endsWith(ART_SUFFIX)) return null;
  return POST_ART[seed.slice(0, -ART_SUFFIX.length)] ?? null;
}
